export enum EventType {
  NEW_ORDER = 'new-order',
  PRODUCT_UPDATE = 'ready-status',
  COMPLETED_ORDER = 'completed-order',
  SETTINGS_CHANGED_BRANCH = 'setting-changed-branch',
  SETTINGS_CHANGED_GLOBAL = 'setting-changed-global',
  LOGOUT = 'logout'
}
